import { useLang } from "../config/i18n";

export const Marquee = () => {
  const { t } = useLang();

  return (
    <div data-testid="editorial-marquee" className="relative py-8 border-y border-[#22222B] overflow-hidden">
      <div className="flex w-max marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0">
            {t.marquee.map((w) => (
              <span key={`${copy}-${w}`} className="flex items-center">
                <span className="font-heading text-sm sm:text-base tracking-[0.3em] uppercase text-[#6E6E7D] px-8 whitespace-nowrap">
                  {w}
                </span>
                <span className="text-[#C5A059] text-xs">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
